import { useState } from "react";
import { Formik } from "formik";
import Input from "../../shared/Input/Input";
import { FORM_TYPE } from "../../../constants/enums/formTypes";
import "./AddClinic.scss";
import Button from "@mui/material/Button";
import FileUpload from "../../shared/Input/FileUpload";
import { userManagement_LABELS } from "../../../constants/labels/UserManagement";
const AddClinic = (props: any) => {
  const { formInitialValues, formRef, formType } = props;
  const [fileUploadErrors, setFileUploadErrors] = useState<any>({
    logo: null,
  });
  function getFileNameFromUrl(url: string | object) {
    if (typeof url == "object") {
      return url && (url as any).fileName;
    }
    let urlParts = (url && url.split("/")) || null;
    return (urlParts && urlParts[urlParts?.length - 1]) || null;
  }
  const validateFileUpload = (file: any) => {
    let supportedTypes =
      process.env.REACT_APP_RIBBON_LOGO_SUPPORTED_TYPES?.split(",") || [
        "image/png",
      ];
    let error = null;
    if (file && supportedTypes.indexOf(file.type) < 0) {
      error = `Upload only ${process.env.REACT_APP_RIBBON_LOGO_SUPPORTED_TYPES} files`;
    } else if (file && file.size >= 30000) {
      error = "File size must be less than 30KB";
    }
    return error;
  };
  return (
    <div className="user-form-container h-100">
      {(formType === FORM_TYPE.ADD || formInitialValues) && (
        <Formik
          innerRef={formRef}
          initialValues={
            formType === FORM_TYPE.ADD
              ? {
                  emailAddress: "",
                  firstName: "",
                  lastName: "",
                  contactNumber: "",
                  clinicId: "",
                  clinicName: "",
                  clinicAddress: "",
                  logo: "",
                  logoURL: "",
                }
              : {
                  ...formInitialValues,
                  contactNumber: formInitialValues.contactNumber
                    ? formInitialValues.contactNumber
                    : "",
                }
          }
          onSubmit={() => {}}
        >
          {(formik) => (
            <form
              //   onKeyDown={Utility.preventSubmitOnEnter}
              onSubmit={formik.handleSubmit}
              className="d-flex flex-column justify-content-between h-100"
            >
              <div className="add-user-form">
                <div className="pb-2">
                  <Input
                    name="clinicName"
                    placeholder="Clinic Name"
                    onChange={formik.handleChange}
                    value={formik.values.clinicName}
                    errorMsg={
                      (formik.touched.clinicName || formik.submitCount > 0) &&
                      formik.errors.clinicName &&
                      (formik.errors as any).clinicName
                    }
                    required
                    disabled={formType === "View"}
                    maxLength={64}
                    label="Clinic Name"
                  />
                  <Input
                    name="clinicAddress"
                    placeholder="Clinic Address"
                    onChange={formik.handleChange}
                    value={formik.values.clinicAddress}
                    errorMsg={
                      (formik.touched.clinicAddress ||
                        formik.submitCount > 0) &&
                      formik.errors.clinicAddress &&
                      (formik.errors as any).clinicAddress
                    }
                    required
                    disabled={formType === "View"}
                    maxLength={64}
                    label="Clinic Address"
                  />
                  <Input
                    name="bpSiteId"
                    placeholder="BP Site ID"
                    onChange={formik.handleChange}
                    value={formik.values.bpSiteId}
                    errorMsg={
                      (formik.touched.bpSiteId || formik.submitCount > 0) &&
                      formik.errors.bpSiteId &&
                      (formik.errors as any).bpSiteId
                    }
                    required
                    disabled={formType === "View"}
                    maxLength={64}
                    label="BP Site ID"
                  />
                </div>
                <div className="h-line">
                  <Input
                    name="firstName"
                    placeholder="First Name"
                    onChange={formik.handleChange}
                    value={formik.values.firstName}
                    errorMsg={
                      (formik.touched.firstName || formik.submitCount > 0) &&
                      formik.errors.firstName &&
                      (formik.errors as any).firstName
                    }
                    required
                    disabled={formType === "View"}
                    maxLength={64}
                    label="First Name"
                  />
                  <Input
                    name="lastName"
                    placeholder="Last Name"
                    onChange={formik.handleChange}
                    value={formik.values.lastName}
                    errorMsg={
                      (formik.touched.lastName || formik.submitCount > 0) &&
                      formik.errors.lastName &&
                      (formik.errors as any).lastName
                    }
                    required
                    disabled={formType === "View"}
                    maxLength={64}
                    label="Last Name"
                  />
                  <Input
                    name={"emailAddress"}
                    placeholder="Email Address"
                    onChange={formik.handleChange}
                    value={formik.values.emailAddress}
                    maxLength={128}
                    errorMsg={
                      (formik.touched.emailAddress || formik.submitCount > 0) &&
                      formik.errors.emailAddress &&
                      (formik.errors as any).emailAddress
                    }
                    required
                    disabled={formType === "Edit" || formType === "View"}
                    label="Email address"
                  />
                  <Input
                    placeholder="Contact Number"
                    name={"contactNumber"}
                    onChange={formik.handleChange}
                    value={formik.values.contactNumber}
                    maxLength={28}
                    required
                    errorMsg={
                      (formik.touched.contactNumber ||
                        formik.submitCount > 0) &&
                      formik.errors.contactNumber &&
                      (formik.errors as any).contactNumber
                    }
                    disabled={formType === "View"}
                    label="Contact Number"
                  />
                  <FileUpload
                    name="Logo"
                    placeholder={userManagement_LABELS.logo}
                    label={userManagement_LABELS.logo}
                    accept={process.env.REACT_APP_RIBBON_LOGO_SUPPORTED_TYPES}
                    errorMsg={""}
                    fileName={getFileNameFromUrl(formik.values.logoURL)}
                    onClear={() => {
                      formik.setFieldValue("logoURL", null);
                      setFileUploadErrors({
                        ...fileUploadErrors,
                        logo: "",
                      });
                    }}
                    onInput={(e) => {
                      let image = (e.target as any).files[0];
                      let reader = new FileReader();
                      reader.onload = function () {
                        let base64String = (reader?.result as string)
                          .replace("data:", "")
                          ?.replace(/^.+,/, "");
                        formik.setFieldValue("logoURL", {
                          fileName: image?.name,
                        });
                        formik.setFieldValue("logo", {
                          fileData: base64String,
                          fileExtension: image?.name?.split(".")[1],
                        });
                      };
                      reader.readAsDataURL(image);
                      setFileUploadErrors({
                        ...fileUploadErrors,
                        logo: validateFileUpload(image),
                      });
                    }}
                    required
                    // infoIconProps={infoIconProps}
                    labelHelpText={
                      <p>
                        Supported Version:{" "}
                        {process.env.REACT_APP_RIBBON_LOGO_SUPPORTED_TYPES?.split(
                          ","
                        ) || "image/png"}{" "}
                        <br />
                        Max. size limit 30KB
                      </p>
                    }
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-3 line-top bg-white py-3 px-4">
                <Button
                  style={{ color: "#696969" }}
                  variant="text"
                  type="button"
                >
                  Cancel
                </Button>
                <Button variant="contained" type="submit">
                  Save
                </Button>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};
export default AddClinic;
